import { render, staticRenderFns } from "./RankingHorsesTable.vue?vue&type=template&id=38d4b699&scoped=true&"
import script from "./RankingHorsesTable.vue?vue&type=script&lang=js&"
export * from "./RankingHorsesTable.vue?vue&type=script&lang=js&"
import style0 from "./RankingHorsesTable.vue?vue&type=style&index=0&id=38d4b699&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d4b699",
  null
  
)

export default component.exports